import { useRef } from "react";
import { TrackEvent } from "../../utils/analytics.ts";

/**
 * Reports the mortgage_calculator GA4 event once, on the first genuine user interaction with a
 * calculator (the input onValueChange callbacks only run on real interaction, never on mount — so a
 * view is never counted as engagement). Returns a callback to invoke from each input handler.
 *
 * Mirrors the legacy Magnum.Web event so historical dashboards keep reconciling: the mortgage
 * repayments calc reported `type: "repayments"`, the maximum-borrowing calc reported `type: "limit"`.
 * The LBTT tax calc (`type: "lbtt"`) is new and had no legacy equivalent.
 */
export function useReportCalculatorInteraction(type: "repayments" | "limit" | "lbtt") {
  const hasReported = useRef(false);
  return () => {
    if (hasReported.current) return;
    hasReported.current = true;
    TrackEvent({ name: "mortgage_calculator", value: 5, event_source: "property_details", type });
  };
}
